import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BehaviorSubject, catchError, Observable, Subject } from 'rxjs';

import { handleError } from '@shared-functions/handle-error.function';
import { CAPTCHA_ACTION } from '@shared/interceptors/captcha.interceptor';
import { ConsultaActaPorUuid } from '@actas-interfaces/consulta-acta-uuid.interface';

@Injectable({
  providedIn: 'root',
})
export class ConsultaActasService {
  private readonly API_SERVER = environment.API_SERVER;

  private readonly estadosSubject = new BehaviorSubject<string[]>([]);

  listaEstados$ = this.estadosSubject.asObservable();
  constructor(private readonly http: HttpClient) {}

  setListaEstados(estados: string[]): void {
    console.log('estados en service:', estados);
    this.estadosSubject.next(estados);
  }

  getInfracciones(
    pTipoBusqueda: any,
    pValor: string,
    captchaToken: string,
    entidadId: string,
  ): Observable<any[]> {
    const params = new HttpParams().appendAll({
      pTipoBusqueda,
      pValor,
      captchaToken,
      entidadId,
    });

    console.log('params:', params.toString());

    return this.http
      .get<any[]>(`${this.API_SERVER}/infraccionesPublico/buscarInfracciones?${params.toString()}`)
      .pipe(catchError(handleError));
  }

  /**
   * Consulta un acta completa por UUID. Destino del QR de la boleta de citación.
   * Devuelve el grupo de infracciones más los datos de la boleta.
   */
  getActaPorUuid(
    uuid: string,
    captchaToken: string,
    entidadId: string,
  ): Observable<ConsultaActaPorUuid> {
    const params = new HttpParams().appendAll({ uuid, captchaToken, entidadId });

    return this.http
      .get<ConsultaActaPorUuid>(`${this.API_SERVER}/infraccionesPublico/actaPorUuid?${params}`)
      .pipe(catchError(handleError));
  }

  descargarPDF(infraccionId: number, uuid: string, entidadId: string): Observable<Blob> {
    const url = `${this.API_SERVER}/infraccionesPublico/imprimirActa`;
    return this.http
      .post(url, { infraccionId, uuid, entidadId }, {
        responseType: 'blob',
        context: new HttpContext().set(CAPTCHA_ACTION, 'descargarActaPDF'),
      })
      .pipe(catchError(handleError));
  }

  imprimirCupon(body: any): Observable<Blob> {
    const url = `${this.API_SERVER}/infraccionesPublico/imprimirCupon`;
    return this.http
      .post(url, body, {
        responseType: 'blob',
        context: new HttpContext().set(CAPTCHA_ACTION, 'imprimirCupon'),
      })
      .pipe(catchError(handleError));
  }

  getListaEstados(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.API_SERVER}/infraccionesPublico/listaEstados`)
      .pipe(catchError(handleError));
  }

  getListaMunicipios(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.API_SERVER}/infraccionesPublico/listaMunicipios`)
      .pipe(catchError(handleError));
  }
}
